import locales from './locales';

export const getPersonalizedTone = ({
  isOlderThanAYear,
  isStoppingActivity,
}: {
  isOlderThanAYear: boolean;
  isStoppingActivity: boolean;
}) => {
  let title = locales.titleClassicBefore1Year;
  let body = `${locales.delayBeforeClosure}${locales.permanentClosure}`;

  if (isOlderThanAYear) {
    title = locales.titleClassicAfter1Year;
    body = `${locales.delayBeforeClosure}${locales.permanentClosure}${locales.classicClosureAfter1Year}`;
  }

  if (isStoppingActivity) {
    title = locales.titleStopActivity;
    body = isOlderThanAYear
      ? `${locales.delayBeforeClosure}${locales.stopActivityAfter1Year}`
      : `${locales.delayBeforeClosure}${locales.stopActivity}`;
  }

  return { body, title };
};
